const getInitials = (name: string) => {
  const _name = name.split(' ');
  const _name_1 = _name.shift();
  const _name_2 = _name.pop();

  if (_name_1 && _name_2) {
    const initials = _name_1.charAt(0) + _name_2.charAt(0);
    return initials.toUpperCase();
  }
  return '';
}

export default getInitials